module.exports = __webpack_public_path__ + "img/checked2.982fe6c3.svg";